function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { actions } from "../../utils/overlay-store";
import Overlay from "./overlay";
import WindowOverflowMixin from "../../mixins/window-overflow-mixin";
import BasicUtils from "../../utils/basic-utils";
var DOM_PROPERTY_WHITELIST = ["height", "left", "scrollTop", "top", "width"];

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false
    });

    _defineProperty(_assertThisInitialized(_this), "checkForOriginChange", function () {
      if (_this.mounted) {
        var node = _this.domNode;

        if (node) {
          var dom_props = BasicUtils.pick(WindowOverflowMixin.getDOMProperties(node), DOM_PROPERTY_WHITELIST);
          var state_dom_props = BasicUtils.pick(_this.state.dom_props, DOM_PROPERTY_WHITELIST);

          if (!_.isEqual(dom_props, state_dom_props)) {
            _this.renderOverlay();
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickToggle", function (e) {
      // _.defer is used to fix the bug where you "outside click"
      // but click on another popover, this prevents it
      // from showing and removing at once and breaking the component
      if (_this.props.event === "click") {
        e.stopPropagation();

        if (!_this.state.open) {
          _.defer(function () {
            return _this.renderOverlay();
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function () {
      if (_this.props.event === "hover") {
        _this.renderOverlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function () {
      if (_this.props.event === "hover") {
        _this.handleClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      clearInterval(_this.poller);

      if (_this.mounted) {
        _this.setState({
          open: false
        });
      }

      actions.removeOverlay(_this.state.overlay_key);
      _this.props.onClose === "function" ? _this.props.onClose() : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "getOverlay", function (dom_props, props) {
      if (props == null) {
        var _assertThisInitialize = _assertThisInitialized(_this);

        props = _assertThisInitialize.props;
      }

      var attrs = _.extend({}, {
        position: props.position,
        width: props.width,
        origin: dom_props,
        arrowPosition: props.arrowPosition,
        onClose: function onClose() {
          return _.defer(_this.handleClose);
        }
      }, props.options);

      return /*#__PURE__*/React.createElement(Overlay, attrs, " ", props.popoverContent(), " ");
    });

    _defineProperty(_assertThisInitialized(_this), "renderOverlay", function (props) {
      if (props == null) {
        var _assertThisInitialize2 = _assertThisInitialized(_this);

        props = _assertThisInitialize2.props;
      }

      if (props.disable) {
        return;
      }

      var dom_props = WindowOverflowMixin.getDOMProperties(_assertThisInitialized(_this));
      var key = _this.state.overlay_key || BasicUtils.randomKey();

      if (_this.mounted) {
        _this.setState({
          open: true,
          dom_props: dom_props,
          overlay_key: key
        });
      }

      actions.overlay(_this.getOverlay(dom_props, props), _.extend(dom_props, {
        key: key
      }));
    });

    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.open && this.state.open) {
        this.poller = setInterval(this.checkForOriginChange, 200);
      }

      if (this.state.open) {
        if (this.props.position !== prevProps.position || this.props.width !== prevProps.width || !_.isEqual(this.props.options, prevProps.options)) {
          this.renderOverlay(this.props);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.poller);
      this.mounted = false;

      if (this.state.overlay_key) {
        this.handleClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(e) {
          return _this2.domNode = e;
        },
        className: classNames("et--popover-trigger", this.props.className, {
          "is-open": this.state.open
        }),
        role: "button",
        tabIndex: "0",
        style: this.props.style,
        onClick: this.handleClickToggle,
        onMouseEnter: this.handleMouseOver,
        onMouseLeave: this.handleMouseOut
      }, this.props.children);
    }
  }]);

  return Popover;
}(React.Component);

_defineProperty(Popover, "displayName", "Popover");

_defineProperty(Popover, "propTypes", {
  event: PropTypes.oneOf(["click", "hover"]),
  position: PropTypes.string,
  width: PropTypes.number,
  options: PropTypes.object,
  onClose: PropTypes.func
});

_defineProperty(Popover, "defaultProps", {
  event: "click"
});

export { Popover as default };